import RichTextBlockView from './RichTextBlockView';
import NoticeBlockView from './NoticeBlockView';
import HeroSliderBlockView from './HeroSliderBlockView';
import PageLinksBlockView from './PageLinksBlockView';
import { AlbumOpenBlockView, AlbumListBlockView, AlbumBlockPlaceholder } from './AlbumBlocksView';
import type { BlockDocument } from '../../api/staticPageBlocks';
import './BlockRenderer.scss';

interface BlockRendererProps {
  document: BlockDocument;
  assetUrls?: Record<string, string>;
  /**
   * When false, the two live album widgets are replaced by inert placeholders.
   * The admin preview renders inside the page editor's `<form>`, and
   * `AlbumOpenBlockView` brings its own `<form>` — nesting those is invalid
   * HTML (React errors on it) and would put a working album-open widget on the
   * edit screen. Defaults to true, so the public pages are unaffected.
   */
  interactive?: boolean;
}

// `assetUrls` resolves admin-preview `f2m-asset://` refs (see `assetSrc`);
// rich_text (inline images in RichDoc columns) and hero_slider consume it.
const BlockRenderer = ({ document, assetUrls, interactive = true }: BlockRendererProps) => (
  <>
    {document.blocks.map((block, i) => {
      switch (block.type) {
        case 'rich_text':
          return <RichTextBlockView key={i} block={block} assetUrls={assetUrls} />;
        case 'notice':
          return <NoticeBlockView key={i} block={block} />;
        case 'hero_slider':
          return <HeroSliderBlockView key={i} block={block} assetUrls={assetUrls} />;
        case 'page_links':
          return <PageLinksBlockView key={i} block={block} />;
        case 'album_open':
          return interactive ? (
            <AlbumOpenBlockView key={i} />
          ) : (
            <AlbumBlockPlaceholder key={i} type="album_open" />
          );
        case 'album_list':
          return interactive ? (
            <AlbumListBlockView key={i} />
          ) : (
            <AlbumBlockPlaceholder key={i} type="album_list" />
          );
        default:
          // Unknown block types render nothing.
          return null;
      }
    })}
  </>
);

export default BlockRenderer;
